__turbopack_context__.v({
  "footer": "Shell-module__08AaNa__footer",
  "inner": "Shell-module__08AaNa__inner",
  "main": "Shell-module__08AaNa__main",
});
